<template>
  <div class="_drawer" @click="drawerClick" v-if="drawerModel">
    <div class="_drawerBox">
      <ul>
        <li @click="gotopage('homepage')">首页-重点数据</li>
        <li @click="gotopage('year')">分届别生源信息数据</li>
        <li @click="gotopage('company')">合作用人单位数据</li>
        <li @click="gotopage('activity')">招聘活动数据</li>
        <li @click="gotopage('work')">就业情况数据</li>
        <li @click="clearCache">清除缓存</li>
      </ul>
      <div class="loginOut" @click="loginOutModel = true">
        退出登录
      </div>
    </div>
  </div>
  <div class="home">
    <!--<el-button circle @click="drawerModel = true" icon="el-icon-menu" style="margin-left: 16px;top: 15px;position: absolute;left: 0;z-index: 2">-->
    <!--</el-button>-->
    <div class="menu flex_c" @click="drawerModel = true">
      <img src="../assets/image/menu_icon.png"/>
    </div>
    <!--{{msg}}-->
    <!--<el-row>-->
      <!--<el-button @click="gotoAbout()">gotoAbout</el-button>-->
      <!--<el-button type="primary" @click="gotohome()">newPage</el-button>-->
      <!--<el-button type="success" @click="gotopage('oldPage')">oldPage</el-button>-->
      <!--<el-button type="info" @click="getStore()">获取store {{storeName}}</el-button>-->
      <!--<el-button type="warning" @click="gotopage('morePage')">morePage</el-button>-->
      <!--<el-button type="warning" @click="gotopage('myComment')">myComment</el-button>-->
      <!--<el-button type="danger">{{title}}次</el-button>-->
      <!--<el-button type="danger" @click="countAdd()">点击我+1</el-button>-->
      <!--<el-button type="danger" @click="deleteCount()">deleteCount</el-button>-->
      <!--<img :src="'data:image/jpeg;base64,'+ imageCode" />-->
      <!--<div ref="stateDom">{{getTitle()}}</div>-->

    <!--</el-row>-->

    <router-view/>

  </div>

  <div class="loginOutPopup" v-if="loginOutModel">
    <div class="loginOutBox">
      <div class="title">
        <span>退出提醒</span>
        <img src="../assets/image/closeIcon.png" class="closeIcon" @click="loginOutModel = false"/>
      </div>
      <div class="content">
        确定要退出登录吗
      </div>
      <div class="footer">
        <span class="clearBtn" @click="loginOutModel= false">取消</span>
        <span class="submitBtn" @click="userLoginOut">确定</span>
      </div>
    </div>
  </div>


</template>

<script lang="ts">
import { Options, Vue} from 'vue-class-component';
import HelloWorld from '@/components/HelloWorld.vue';
import {useStore} from "vuex"; // @ is an alias to /src

import  {getLocalStorage,setLocalStorage,loginOutDataClear} from "@/public/storage";
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';


// 首先，在 vue 3.0 中，生命周期是从 vue 中导出的，我们需要用到哪些，就导出哪些。
import { defineComponent,ref, onBeforeMount,computed,
  onMounted,
  onBeforeUpdate,
  onUpdated,
  onBeforeUnmount,
  onUnmounted,
  getCurrentInstance,
  reactive
} from "vue";
import basicApi from '../public/http/index';

export default {
  //始化数据,介于beforeCreate与created之间，相当于beforeCreate、created的合并
  setup() {
    const count = ref(0);
    const storeName = ref('');
    const imageCode = ref('');
    const title = ref('这是data的数据');
    const drawerModel = ref(false);
    const loginOutModel = ref(false);

    const stateDom = ref(null);
    const ctx:any = null;
    const router = useRouter();
    // ctx = getCurrentInstance();

    // var obj: any = Object.create(null);
    var obj: any  = getCurrentInstance();
    console.log('home_ctx',obj)
    setLocalStorage('key', 'aaaa');
    console.log('setup', useStore);
    const hello: string = "Hello World!";
    console.log(hello);

    let json =  localStorage.getItem('collegeDetail')
    if(json){
      let  collegeDetail = JSON.parse(json)
      console.log('get_screen_background',collegeDetail,)

      basicApi.get_screen_background(collegeDetail.collegeid).then((res:any) => {
        if(res.data.background){
          console.log('get_screen_background',res.data.background)
          localStorage.setItem('background',JSON.stringify(res.data.background))
        }
      }).catch((err:any) => {
        console.log('getData', err)
      });
    }

    computed(() => {
      storeName.value = useStore().state.name
      // let collogeId:string = localStorage.getItem('collegeId')



    })
    storeName.value = useStore().state.name;

    // 其他的生命周期都写在这里
    onBeforeMount(() => {
      count.value++
      console.log('onBeforeMount', count.value)
    })
    onMounted(() => {
      count.value++



    })
    // 注意，onBeforeUpdate 和 onUpdated 里面不要修改值，会死循环的哦！
    onBeforeUpdate(() => {
      console.log('onBeforeUpdate', count.value)
    })
    onUpdated(() => {
      console.log('onUpdated', count.value)
    });
    onBeforeUnmount(() => {
      count.value++;
      console.log('onBeforeUnmount', count.value)
    })
    onUnmounted(() => {
      count.value++;
      console.log('onUnmounted', count.value)
    })
    // 定义一个函数，修改 count 的值。
    const countAdd = () => {
      count.value++;
    };

    function deleteCount() {
      count.value = 0;
    }

    function getTitle() {
      return '张大海 ----> 这是带有返回值的函数'
    }

    function getHTTPdate() {
      count.value = 0;
    }

    const drawerClick = () => {
      drawerModel.value = false;
    }

    function  userLoginOut() {
        ElMessage('退出成功');
        let collegeId = getLocalStorage('collegeId');
        loginOutDataClear();
        router.push({path:"/login",query:{collegeId:collegeId}});
    }


    return {
      count,
      countAdd,
      deleteCount,
      storeName,
      imageCode,
      stateDom,
      title,
      getTitle,
      drawerModel,
      drawerClick,
      loginOutModel,
      userLoginOut
    }
  },
  computed: {},

  methods: {
    gotoAbout() {
      console.log('gotoAbout');
      this.$router.push('/about')
    },
    gotohome() {
      this.$router.push('/home/newPage')
    },
    gotopage(page: any) {
      // this.$router.push('/home/' + page)

      let routeUrl = this.$router.resolve({
        path:'/home/' + page
      });
      window.open(routeUrl.href, '_blank');
    },
    getStore() {
      console.log('getStore', this.$store.state.name);
      this.storeName = this.$store.state.name;
    },
    updateStoreClick() {
      this.$store.commit('setTitle', new Date())
      console.log('getStore', this.$store.state.name)

    },
    clearCache(){
      basicApi.clear_cache().then((res:any) => {
        console.log(4444,res)
        if(res.status){
          ElMessage('清除成功');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
    }
  },
}

// @Options({
//   components: {
//     HelloWorld,
//   },
// })
// export default class Home extends Vue {
//   name:string='asdasdasd';
//   msg: string = '这是公共的头部';
//   //需要非常注意的是在vue3.0的setup 函数中是无法访问到this的
//   setup() {
//     const store = useStore();
//     console.log('setup',store)

//   }
//     gotoAbout(){
//     console.log('gotoAbout')
//     this.$router.push('/about')
//   }
//   gotohome(){
//     this.$router.push('/home/newPage')
//   }
//   gotopage(page:any){
//     this.$router.push('/home/'+ page)

//   }
//   getStore(){
//      console.log('getStore',this.name)
//   }
// }
</script>
<style>
  ._drawer{
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    z-index: 4;
    animation:_drawerbg 0.1s;
    cursor: pointer;
  }
  @keyframes _drawerbg {
    0%   {background-color: rgba(0,0,0,0.1)}
    25%   {background-color: rgba(0,0,0,0.2)}
    50%  {background-color: rgba(0,0,0,0.3)}
    75%  {background-color: rgba(0,0,0,0.4)}
    100% {background-color: rgba(0,0,0,0.5)}
  }
  ._drawerBox {
    width: 400px;
    background-color: rgba(5, 8, 43, 1);
    height: 100%;
    position: absolute;
    /*transform:translate(0px,0px);*/
    top: 0;
    left: 0;
  }
  ._drawerBox ul{
    list-style: none;
    padding-left: 0;
  }
  ._drawerBox ul li {
    text-align: left;
    line-height: 50px;
    padding-left: 40px;
    cursor: pointer;
    color: white;
  }
  ._drawerBox ul li:hover{
    background-color: white;
    color: rgba(5, 8, 43, 1);
  }
  @media screen and (max-width: 600px) {
    ._drawerBox {
      width: 220px;
    }
  }
  .loginOut {
    position: absolute;
    bottom: 45px;
    left: 35px;
    right: 35px;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: 1px white solid;
    color: white !important;
    border-radius: 3px;
  }
  .loginOut:hover{
    color:white !important;
    background-color: rgba(5, 8, 43, 1);
    font-size: 15px;
  }
  .ant-message .anticon {
    position: relative;
    top: -2px !important;
    margin-right: 8px;
    font-size: 16px;
  }

  /*  退出登录弹窗 start */
  .loginOutPopup{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background-color: rgba(0,0,0,0.5);
  }

  .loginOutPopup .loginOutBox{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    width: 520px;
    height: 180px;
    background: #fff;
  }

  .loginOutPopup .loginOutBox .title{
    padding: 16px 24px;
    color: rgba(0,0,0,.85);
    border-bottom: 1px solid #f0f0f0;
    border-radius: 2px 2px 0 0;
   }

  .loginOutPopup .loginOutBox .title .closeIcon{
    height: 16px;
    width: 16px;
    float: right;
    cursor: pointer;
  }

  .loginOutPopup .loginOutBox .content{
    padding: 24px;
    font-size: 14px;
  }

  .loginOutPopup .loginOutBox .footer{
    text-align: right;
    padding: 10px 16px;
    border-top: 1px solid #f0f0f0;
  }

  .loginOutPopup .loginOutBox .footer .submitBtn{
    margin-left: 10px;
    background: #1890ff;
    color: #fff;
  }

  .loginOutPopup .loginOutBox .footer .clearBtn{
    background: #fff;
    color: #333;
  }


  .loginOutPopup .loginOutBox .footer .clearBtn,  .loginOutPopup .loginOutBox .footer .submitBtn{
    display: inline-block;
    height: 32px;
    line-height: 32px;
    border: 1px solid #999;
    width: 65px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }

  /*  退出登录弹窗end */

  @media screen and (max-width: 600px) {
    ._drawerBox {
      width: 220px;
    }

    .loginOutPopup .loginOutBox{
      width: 80%;
    }
  }
  .menu{
    width: 35px;height: 35px;position: fixed;left: -10px;z-index: 2;top: -15px;
    padding: 15px;
    cursor: pointer;
  }
  .menu img{

    width: 20px;
    height: 20px;
  }

</style>

